import type { BankAccountResource } from "../../bank-account";

export interface AccountingAccountResource {
  id: string;
  gid: string;
  is_important?: boolean;
  account_number: string;
  title: string;
  accounting_category: AccountingAccountCategoryEnum;
  mode: AccountingAccountModeEnum;
  type: string | null;
  vat_percent: string | null;
  country_id: string | null;
  customer_id: string | null;
  supplier_id: string | null;
  bankAccounts?: BankAccountResource[];
}

export enum AccountingAccountCategoryEnum {
  Depreciation = "Depreciation",
  FixedAssets = "FixedAssets",
  Expenditure = "Expenditure",
  Inventory = "Inventory",
  Income = "Income",
  Demands = "Demands",
  "Cash/Bank" = "Cash/Bank",
  NonDeductibleExpenses = "NonDeductibleExpenses",
  Private = "Private",
  Provisions = "Provisions",
  Other = "Other",
  Vat = "Vat",
  Liabilities = "Liabilities",
  InputTax = "InputTax",
}

export enum AccountingAccountModeEnum {
  Customer = "Customer",
  Supplier = "Supplier",
  Bank = "Bank",
}
